export default __webpack_public_path__ + "3921b67eefbc13f9629230b71fc36cb5.png";